<template>
  <div class='animated fadeIn'>
    <b-row v-if="$route.name === 'Tickets'">
      <b-col lg='12'>
        <b-card title="<b>Ticket</b> List" sub-title="">
          <b-row class="mt-4">
            <b-col lg='4' md='3'>
              <b-form-group
                label="Period"
                label-for="createdAt"
                :label-cols="2"
                :horizontal="true">
                <date-picker v-model="filterBy.DateTime" range format="dd/MM/yyyy" lang="en" width="212" :not-after="filterBy.DateTimeNotAfter" placeholder=" "></date-picker>
              </b-form-group>
            </b-col>
            <b-col lg='4' md='3'>
              <b-form-group
                label="Status"
                label-for="taskStatus"
                :label-cols="2"
                :horizontal="true">
                <b-form-select v-model="filterBy.task_status_uuid" :options="filterBy.taskStatusList">
                  <template slot="first">
                    <option :value="null">All Status</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg='2' md='2'>
              <b-button variant="success" class="btn-rounded mb-3" @click="doFilter()">
                <i class="fa fa-search"></i>
              </b-button>
            </b-col>
            <b-col lg='2' md='2' class="text-right">
              <b-button href="#/tickets/create" size="lg" class="btn-rounded mb-3" variant="success">
                <i class="fa fa-plus"></i>
              </b-button>
            </b-col>
          </b-row>

          <c-server-table
            :url="apiUrl"
            :columns="columns"
            :options="options"
            :method_1="getStatusColor"
            ref="dataTable">
          </c-server-table>

        </b-card>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
    <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import cServerTable from '@/views/components/cServerTable'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'complaintIndex',
  components: {
    cServerTable,
    DatePicker
  },
  data () {
    // table config
    let config = cServerTable.methods.setTableConfig({
      columns: [
        'name',
        'createdBy',
        // 'requestedBy',
        'assigned',
        // 'assignedRole',
        // 'taskCategory',
        'taskStatus',
        'createdAt',
        'actionButtons3'
      ],
      options: {
        headings: {
          name: 'Name',
          createdBy: 'Created By',
          requestedBy: 'Requested By',
          assigned: 'Assigned',
          assignedRole: 'Role',
          taskCategory: 'Category',
          taskStatus: 'Status',
          createdAt: 'Created Time',
          actionButtons3: ''
        },
        sortable: ['createdAt'],
        uniqueKey: 'uuid',
        params: {
          assignedRole: this.$route.query.role,
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          task_status_uuid: this.$route.query.task_status_uuid,
          task_category_uuid: 'a2c92744-ecd5-4276-88e9-70a8ac41154d'
        },
        templates: {
          createdAt (h, row) {
            return row.createdAt !== null ? moment(row.createdAt).format(window.AppConfig.dateFormat) : '-'
          },
          createdBy (h, row) {
            return row.createdBy.name
          },
          requestedBy (h, row) {
            return row.requestedBy.name
          },
          assigned (h, row) {
            return row.assigned.name
          },
          assignedRole (h, row) {
            return row.assigned.role !== null ? row.assigned.role.charAt(0).toUpperCase() + row.assigned.role.slice(1) : '-'
          }
        }
      }
    }, 'task')

    // data returned
    return {
      apiUrl: window.AppConfig.apiUrl + 'task?descending=1',
      apiUrlTaskStatus: window.AppConfig.apiUrl + 'task-status',
      apiUrlTaskCategory: window.AppConfig.apiUrl + 'task-category',
      // vue-table-2 config
      columns: config.columns,
      options: config.options,
      // filter var
      filterBy: {
        DateTime: window.setDefaultNull(this.$route.query.start_date) === null ? null : [window.setDefaultNull(this.$route.query.start_date), window.setDefaultNull(this.$route.query.end_date)],
        taskStatusList: [],
        taskCategoryList: [],
        assignedRole: this.$route.query.role,
        task_status_uuid: window.setDefaultNull(this.$route.query.task_status_uuid),
        task_category_uuid: 'a2c92744-ecd5-4276-88e9-70a8ac41154d',
        DateTimeNotAfter: moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted () {
    this.initDropdownOptions_TaskStatus()
    // this.initDropdownOptions_TaskCategory()
  },
  methods: {
    initDropdownOptions_TaskStatus () {
      var self = this
      axios.get(this.apiUrlTaskStatus)
        .then(response => {
          if (response !== undefined) {
            let datas = response.data._embedded.taskStatus
            datas.sort((a, b) => parseInt(a.order) - parseInt(b.order))
            for (let i = 0; i < response.data.total_items; i++) {
              self.filterBy.taskStatusList.push({text: datas[i].name, value: datas[i].uuid})
            }
          }
        })
        .catch(function (error) {
          self.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              self.$alertify.error(errMsg)
            })
        }) // .bind(this)
    },
    initDropdownOptions_TaskCategory () {
      var self = this
      axios.get(this.apiUrlTaskCategory)
        .then(response => {
          if (response !== undefined) {
            let datas = response.data._embedded.taskCategory
            datas.sort((a, b) => parseInt(a.order) - parseInt(b.order))
            for (let i = 0; i < response.data.total_items; i++) {
              self.filterBy.taskCategoryList.push({text: datas[i].name, value: datas[i].uuid})
            }
          }
        })
        .catch(function (error) {
          self.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              self.$alertify.error(errMsg)
            })
        }) // .bind(this)
    },

    getStatusColor (status) {
      switch (status) {
        case 'Assigned':
          return 'warning'
        case 'Accepted':
          return 'info'
        case 'In Progress':
          return 'primary'
        case 'Completed':
          return 'success'
        default:
          return 'danger'
      }
    },

    doFilter () {
      if (this.filterBy.DateTime !== null && this.filterBy.DateTime !== '') {
        this.options.params.start_date = moment(this.filterBy.DateTime[0]).format('YYYY-MM-DD')
        this.options.params.end_date = moment(this.filterBy.DateTime[1]).format('YYYY-MM-DD')
      } else {
        this.options.params.start_date = null
        this.options.params.end_date = null
      }
      this.options.params.assignedRole = this.filterBy.assignedRole
      this.options.params.task_status_uuid = window.setDefaultNull(this.filterBy.task_status_uuid)
      this.options.params.task_category_uuid = 'a2c92744-ecd5-4276-88e9-70a8ac41154d'
      this.$refs.dataTable.options.params = this.options.params
      this.$refs.dataTable.setTableDatas()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/tasks/Index.vue